@if (zone) {
    <div class="value-drag-parent" [ngClass]="{'readonly': isReadOnly}">
        <h3>{{ zone.label }}{{ zone.mandatory ? '*' : '' }}</h3>

        <div class="drag-wrap {{zone.configKey}}"
            cdkDropList
            [cdkDropListData]="dataConfigs"
            (cdkDropListDropped)="onDrop($event, zone)"
            [ngClass]="{'disabled':!zone.allowed && activelyDragging, 'allowed-area':zone.allowed && activelyDragging}"
        >
            @for (dataConfig of dataConfigs; track dataConfig.colId) {
                <app-ddv-configuration-field
                    cdkDrag
                    cdkDragBoundary=".{{zone.configKey}}"
                    id="{{dataConfig.colId}}"
                    class="drag-list"
                    [dataConfig]="dataConfig"
                    [zone]="zone"
                    [visualizationType]="visualizationType"
                    (removeConfigField)="removeConfig($event)"
                    (configurationFieldChange)="configurationZoneChange.emit({ dataConfigs, key: zone.configKey })">
                </app-ddv-configuration-field>
            }

            <label class="drag-placeholder">
                {{ zone.placeholder }}
            </label>
        </div>
    </div>
}
